
const headers = [
    {
      label: 'กอง',
      field: 'departmentName',
    },
    {
      label: 'บริษัท',
      field: 'compName',      
    },
    {
      label: 'จัดการ',
      field: 'action', 
    },
  ]

  export default headers